import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { notyf } from '../utils/Notyf';

export const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
  const [blogs, setBlogs] = useState([]);
  const { authToken, user } = useContext(AuthContext);
  const navigate = useNavigate();

  // useEffect(() => {
  //   getBlogs();
  // }, []);

/*  const getBlogs = async () => {
    try {
      const response = await fetch('https://blog-app-2-v2of.onrender.com/blogs/getBlogs', {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch blogs');
      }
      const data = await response.json();
      setBlogs(data.blogs);
    } catch (error) {
      // console.error('Error fetching posts:', error);
      notyf.error('Could not load posts');
    }
  }; */

  const getBlogs = useCallback(async () => {
  try {
    const response = await fetch(
      'https://blog-app-2-v2of.onrender.com/blogs/getBlogs',
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch blogs');
    }

    const data = await response.json();
    setBlogs(data.blogs);
  } catch (error) {
    notyf.error('Could not load posts');
  }
}, [authToken]);

  useEffect(() => {
  getBlogs();
}, [getBlogs]);



  const addBlog = async (blog) => {
    try {
      const response = await fetch('https://blog-app-2-v2of.onrender.com/blogs/addBlog', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify(blog)
      });
      if (!response.ok) {
        throw new Error('Failed to add post');
      }
      const data = await response.json();
      setBlogs((prevBlogs) => [...prevBlogs, data]);
      notyf.success('Post added successfully!');
      return data._id;
    } catch (error) {
      // console.error('Error adding post:', error);
      notyf.error('Failed to add post');
    }
  };

  const editBlog = async (id, blog) => {
    try {
      const response = await fetch(`https://blog-app-2-v2of.onrender.com/blogs/updateBlog/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify(blog)
      });
      if (!response.ok) {
        throw new Error('Failed to edit post');
      }
      const data = await response.json();
      setBlogs(blogs.map(b => (b._id === id ? data : b)));
      notyf.success('Post updated successfully!');
    } catch (error) {
      // console.error('Error editing post:', error);
      notyf.error('Failed to update post');
    }
  };

/*   const deleteBlog = async (id) => {
    try {
      const response = await fetch(`https://blog-app-2-v2of.onrender.com/blogs/deleteBlog/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (!response.ok) {
        throw new Error('Failed to delete post');
      }
      setBlogs((prevBlogs) => prevBlogs.filter((b) => b._id !== id));
      notyf.success('Post deleted successfully!');
      setTimeout(() => {
        navigate('/profile/posts', { replace: true });
      }, 0);
    } catch (error) {
      console.error('Error deleting post:', error);
      notyf.error('Failed to delete post');
    }
  }; */

  const deleteBlog = async (id) => {
  try {
    const response = await fetch(`https://blog-app-2-v2of.onrender.com/blogs/deleteBlog/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to delete post');
    }
    setBlogs((prevBlogs) => prevBlogs.filter((b) => b._id !== id));
    notyf.success('Post deleted successfully!');
    setTimeout(() => {
      if (user && user.isAdmin) {
        navigate('/posts', { replace: true }); 
      } else {
        navigate('/profile/posts', { replace: true }); 
      }
    }, 0);
  } catch (error) {
    // console.error('Error deleting post:', error);
    notyf.error('Failed to delete post');
  }
};

  

  const getMyBlogs = async () => {
    try {
      const response = await fetch('https://blog-app-2-v2of.onrender.com/blogs/getMyBlogs', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch my posts');
      }
      const data = await response.json();
      return data.blogs;
    } catch (error) {
      // console.error('Error fetching my posts:', error);
      notyf.error('Could not load your posts');
      throw error;
    }
  };

  return (
    <BlogContext.Provider value={{ blogs, getBlogs, addBlog, editBlog, deleteBlog, getMyBlogs }}>
      {children}
    </BlogContext.Provider>
  );
};
